import { Eye } from 'lucide-react';

import type { TFunction } from 'i18next';

import type { ReceiveLossTableData } from '@/entities/receive';
import type { TableAction } from '@/shared/ui/data-table';

interface BuildReceiveLossesRowActionsArgs {
  onShowDisposition: (consignmentId: string) => void;
  t: TFunction;
}

/**
 * Per-row actions for the losses table — mirrors the receive-history table:
 * open the consignment's Line Disposition dialog.
 */
export function buildReceiveLossesRowActions({
  onShowDisposition,
  t
}: BuildReceiveLossesRowActionsArgs): TableAction<ReceiveLossTableData>[] {
  return [
    {
      id: 'show-disposition',
      label: t('cmrlist.showdisposition.label', 'Show Disposition'),
      icon: Eye,
      onClick: (row) => onShowDisposition(row.consignmentId)
    }
  ];
}
